import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Subprovider } from '@bitski/provider-engine';
import asyncify from 'async/asyncify';
import retry from 'async/retry';
import waterfall from 'async/waterfall';
import fetch from 'cross-fetch';
import JsonRpcError from 'json-rpc-error';
import promiseToCallback from 'promise-to-callback';
var RETRIABLE_ERRORS = [// ignore server overload errors
'Gateway timeout', 'ETIMEDOUT', // ignore server sent html error pages
// or truncated json responses
'SyntaxError'];
var MATCHING_METHODS = ['eth_getBlockByNumber', 'eth_blockNumber', 'net_Version', 'eth_getLogs'];
export var RestFetchSubprovider = /*#__PURE__*/function (_Subprovider) {
  _inherits(RestFetchSubprovider, _Subprovider);

  var _super = _createSuper(RestFetchSubprovider);

  function RestFetchSubprovider(opts) {
    var _this;

    _classCallCheck(this, RestFetchSubprovider);

    _this = _super.call(this);
    _this.rpcUrl = opts.rpcUrl;
    _this.defaultHeaders = opts.defaultHeaders;
    _this.originHttpHeaderKey = opts.originHttpHeaderKey;
    return _this;
  }

  _createClass(RestFetchSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      if (MATCHING_METHODS.includes(payload.method)) {
        this.handleRestRequest(payload, end);
      } else {
        next();
      }
    }
  }, {
    key: "handleRestRequest",
    value: function handleRestRequest(payload, end) {
      var _this2 = this;

      var originDomain = payload.origin;
      var query = payload.params.length > 0 ? "?params=".concat(encodeURIComponent(JSON.stringify(payload.params))) : '';
      var url = "".concat(this.rpcUrl, "/").concat(payload.method).concat(query);
      var reqParams = {
        method: 'GET',
        headers: Object.assign({
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, this.defaultHeaders),
        credentials: 'omit'
      };

      if (this.originHttpHeaderKey && originDomain) {
        reqParams.headers[this.originHttpHeaderKey] = originDomain;
      }

      retry({
        times: 5,
        interval: 1000,
        errorFilter: isErrorRetriable
      }, function (cb) {
        return _this2._submitRequest(url, reqParams, cb);
      }, function (err, result) {
        // ends on retriable error
        if (err && isErrorRetriable(err)) {
          var errMsg = "FetchSubprovider - cannot complete request. All retries exhausted.\nOriginal Error:\n".concat(err.toString(), "\n\n");
          var retriesExhaustedErr = new Error(errMsg);
          return end(retriesExhaustedErr);
        } // otherwise continue normally


        return end(err, result);
      });
    }
  }, {
    key: "_submitRequest",
    value: function _submitRequest(targetUrl, reqParams, done) {
      promiseToCallback(fetch(targetUrl, reqParams))(function (err, res) {
        if (err) {
          return done(err);
        } // continue parsing result


        waterfall([checkForHttpErrors, // buffer body
        function (cb) {
          return promiseToCallback(res.text())(cb);
        }, // parse body
        asyncify(function (rawBody) {
          return JSON.parse(rawBody);
        }), parseResponse], done);

        function checkForHttpErrors(cb) {
          // check for errors
          switch (res.status) {
            case 405:
              return cb(new JsonRpcError.MethodNotFound());

            case 418:
              return cb(createRatelimitError());

            case 503:
            case 504:
              return cb(createTimeoutError());

            default:
              return cb();
          }
        }

        function parseResponse(body, cb) {
          // check for error code
          if (res.status !== 200) {
            return cb(new JsonRpcError.InternalError(body));
          }

          cb(null, body);
        }
      });
    }
  }]);

  return RestFetchSubprovider;
}(Subprovider);

function isErrorRetriable(err) {
  var errMsg = err.toString();
  return RETRIABLE_ERRORS.some(function (phrase) {
    return errMsg.includes(phrase);
  });
}

function createRatelimitError() {
  var msg = 'Request is being rate limited.';
  var err = new Error(msg);
  return new JsonRpcError.InternalError(err);
}

function createTimeoutError() {
  var msg = 'Gateway timeout. The request took too long to process. ';
  msg += 'This can happen when querying logs over too wide a block range.';
  var err = new Error(msg);
  return new JsonRpcError.InternalError(err);
}